import graphql__e9a350cfda0188ceda45 from "./__generated__/AnswerPreviewPresentationSeparator_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

const AnswerPreviewPresentationSeparator = function() {
  return null;
};

export default createFragmentContainer(AnswerPreviewPresentationSeparator, {
  answer: graphql__e9a350cfda0188ceda45
});
